import {
	Button, Icon
} from "~/components";
import { Tooltip } from "antd";

function SupplierAction({ item, setItemEdit, openModal, can}) {

	const buttonHandlers = {
		edit: () => {
			setItemEdit(item);
			openModal('addEdit');
		},
		delete: () => {
			setItemEdit(item);
			openModal('delete');
		}
	};

	return (
		<div className="table-action d-flex">
			{(can.edit ) && (<Tooltip title="Cập nhật thông tin"><Button background blue noneBorder leftIcon={Icon.edit} onClick={buttonHandlers.edit} /></Tooltip>)}
			{can.delete && (
				<Tooltip title="Xóa nhà cung cấp">
					<Button background red noneBorder leftIcon={Icon.delete} onClick={buttonHandlers.delete} />
				</Tooltip>
			)}
		</div>
	);
}

export default SupplierAction;
